import { useState } from 'react';
import { mediaUrl } from '@/lib/api';
import { BrandLogo } from '@/components/common/BrandLogo';

/**
 * SafeImage: renders an <img> with graceful fallback if the URL fails.
 * - Runs mediaUrl() unless the url is already absolute.
 * - If load fails, shows a branded placeholder with Ok te lo vendo logo.
 * - Accepts all standard <img> props (className, alt, ...).
 */
export const SafeImage = ({ src, alt = '', className = '', wrapperClassName = '', placeholder = 'Imagen no disponible', ...rest }) => {
    const [failed, setFailed] = useState(false);
    const resolved = src ? mediaUrl(src) : '';

    if (!resolved || failed) {
        return (
            <div
                className={`flex flex-col items-center justify-center gap-2 bg-gradient-to-br from-[hsl(var(--secondary))] to-[hsl(var(--accent))] text-muted-foreground ${className} ${wrapperClassName}`}
                role="img"
                aria-label={placeholder}
                data-testid="safe-image-fallback"
            >
                <BrandLogo size={44} className="opacity-70" />
                <span className="text-[10px] px-3 text-center leading-tight tracking-wide uppercase">{placeholder}</span>
            </div>
        );
    }
    return (
        <img
            src={resolved}
            alt={alt}
            className={className}
            loading="lazy"
            onError={() => setFailed(true)}
            {...rest}
        />
    );
};

export default SafeImage;
